var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown"},[_c('div',{staticClass:"dropdown__label",class:{ active: _vm.visibility },on:{"click":_vm.toggle}},[_vm._t("label")],2),(_vm.visibility)?_c('div',{staticClass:"dropdown__content"},[_vm._t("content")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }